export const shuffle = (array) => {
  let currentIndex = array.length,
    randomIndex;
  while (currentIndex != 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }
  return array;
};

export const addStep = (component, tour, element, position = "bottom", cancelBtn = false, prevBtn = true, nextBtn = true )=>{
        const step = {
              attachTo: { element: "#"+element, on: 'bottom' },
              text: component.$t('shepherd.'+element),
              cancelIcon : {enabled:true},
              canClickTarget :false,
              buttons: []
        };
        if(cancelBtn) {
            step.buttons.push({
                text: component.$t('shepherd.cancel'),
                action: tour.cancel
            })
        }
         if(prevBtn) {
            step.buttons.push({
                text: component.$t('shepherd.back'),
                action: tour.back
            })
        }
        if(nextBtn) {
            step.buttons.push({
                text: component.$t('shepherd.next'),
                action: tour.next
            })
        }
        tour.addStep(step);  
    }

export const calculateQuestionPoints = (questExam, calcMode = "FULL_MATCH") =>{
      if (!questExam.haveAnyAnswer) {
          return 0;
      }
      let points = 0;

      if (isSimpleQuestion(questExam)) {
        const selected = questExam.answerExams.filter(answer=> answer.isChecked);
        if(selected.length==1){
            points =  calculateAnswerPoints(selected[0],questExam, calcMode);
        }else{
            //multiple selections for complement simplu
            points =  0;
        }
      }
      else{
        questExam.answerExams.forEach(answer => { points += calculateAnswerPoints(answer, questExam, calcMode); });
      }
      if (points > 0) {
        return points;
    }
      return 0;
  }

export const isSimpleQuestion = (questExam) => {
      const numOfCrAns = questExam.answerExams.filter(a => a && a.answer && a.answer.isCorrect).length;
      return numOfCrAns == 1;
  };

export const calculateAnswerPoints = (answer, questExam,calcMode = "FULL_MATCH") => {    
    const questionPoints = questExam.question.points;
      //simple question 
      if (isSimpleQuestion(questExam)) {
          if (answer.isChecked && answer.answer.isCorrect) {
              return questionPoints;
          } else {
              return -1*questionPoints;
          }
      }
      else {
        const checkedAnswers = questExam.answerExams.filter(a => a && a.isChecked).length;
      const correctCheckedAnswers = questExam.answerExams.filter(a => a && a.isChecked && a.answer.isCorrect).length;
      const incorrectCheckedAnswers = questExam.answerExams.filter(a => a && a.isChecked && !a.answer.isCorrect).length;
      const questionCorrectAnswers = questExam.answerExams.filter(a => a && a.answer && a.answer.isCorrect).length;
      const questionIncorrectAnswers = questExam.answerExams.filter(a => a && a.answer && !a.answer.isCorrect).length;
        switch (calcMode) {
            case "PERFECT_MATCH" : {
                //no incorrect answer checked
                if(incorrectCheckedAnswers == 0 ){
                    //all correct answers checked
                    if(answer.isChecked && correctCheckedAnswers == questionCorrectAnswers){
                        return questionPoints/questionCorrectAnswers;
                    }else{
                        return 0;
                    }
                }
                else {
                    //incorrect answer checked, so 0 for each answer
                    return 0;
                }
                break;
            }
            case "NEGATIVE_MARKING" : {
                if (checkedAnswers <= 1 || checkedAnswers >= questExam.answerExams.length) {
                    return 0;
                }
                const wrongSelectionPoints = -1 * (questionPoints/questionIncorrectAnswers);
                const correctSelectionPoints = questionPoints/questionCorrectAnswers;
                if(answer.isChecked){
                    if(answer.answer.isCorrect){
                        return correctSelectionPoints;
                    }else{
                        return wrongSelectionPoints;
                    }
                }else{
                    return 0;
                }
                break;
            }
            case "JUST_CORRECT" : {
                //no incorrect answer checked
                if(incorrectCheckedAnswers == 0 ){
                    if(answer.isChecked){
                        //correct answer checked
                        return questionPoints/questionCorrectAnswers;
                    }else{
                        return 0;
                    }
                }
                else {
                    //incorrect answer checked, so 0 for each answer
                    return 0;
                }
                break;
            }
            case "FULL_MATCH" : {
                //this is the default one 
            }
            default : {
                //count how many were answered 
                //TODO this should be from settings 
                if (checkedAnswers <= 1 || checkedAnswers >= questExam.answerExams.length) {
                    return 0;
                }
                const perAnswerPoints = questionPoints / questExam.answerExams.length;
                if (answer.isChecked) {
                    if (answer.answer.isCorrect) {
                        return perAnswerPoints;
                    } else {
                        return 0;
                    }
                } else {
                    if (!answer.answer.isCorrect) {
                        return perAnswerPoints;
                    }
                    return 0;
                }
            }
        }
      }
}

export const getAnswerPoints = (answer, questExam,calcMode = "FULL_MATCH") => {    
    const questionPoints = questExam.question.points;
      //simple question 
      if (isSimpleQuestion(questExam)) {
          if (answer.answer.isCorrect) {
              return questionPoints;
          } else {
              return 0;
          }
      }
      else {
        const checkedAnswers = questExam.answerExams.filter(a => a && a.isChecked).length;
        const correctCheckedAnswers = questExam.answerExams.filter(a => a && a.isChecked && a.answer.isCorrect).length;
        const incorrectCheckedAnswers = questExam.answerExams.filter(a => a && a.isChecked && !a.answer.isCorrect).length;
        const questionCorrectAnswers = questExam.answerExams.filter(a => a && a.answer && a.answer.isCorrect).length;
        const questionIncorrectAnswers = questExam.answerExams.filter(a => a && a.answer && !a.answer.isCorrect).length;
        switch (calcMode) {
            case "PERFECT_MATCH" : {
                if (checkedAnswers <= 1 || checkedAnswers >= questExam.answerExams.length) {
                    return 0;
                }
                const wrongSelectionPoints = -1 * (questionPoints);
                const correctSelectionPoints = questionPoints/questionCorrectAnswers;
                if(answer.answer.isCorrect){
                    return correctSelectionPoints;
                }else{
                    return wrongSelectionPoints;
                }
            }
            case "NEGATIVE_MARKING" : {
                const wrongSelectionPoints = -1 * (questionPoints/questionIncorrectAnswers);
                const correctSelectionPoints = questionPoints/questionCorrectAnswers;
                if(answer.answer.isCorrect){
                    return correctSelectionPoints;
                }else{
                    return wrongSelectionPoints;
                }
            }
            case "JUST_CORRECT" : {
                const wrongSelectionPoints = -1 * (questionPoints);
                const correctSelectionPoints = questionPoints/questionCorrectAnswers;
                if(answer.answer.isCorrect){
                    return correctSelectionPoints;
                }else{
                    return wrongSelectionPoints;
                }
            }
            case "FULL_MATCH" : {
                //this is the default one 
            }
            default : {
                if (checkedAnswers <= 1 || checkedAnswers >= questExam.answerExams.length) {
                    return 0;
                }
                return questionPoints/(questionCorrectAnswers+ questionIncorrectAnswers);
            }
        }
      }
  }

export const calculateGrade = (score, questions)=>{
    return parseFloat(
        (parseFloat(score).toFixed(2) /
          (questions * 10)) *
        9 +
        1
      ).toFixed(2)
}

  
